import type { InputHTMLAttributes } from 'react';
import { useEnvironment } from '../../context/EnvironmentContext';

export function Input({ className = '', ...props }: InputHTMLAttributes<HTMLInputElement>) {
  const { accentRing } = useEnvironment();
  return <input className={`input-field ${accentRing} ${className}`} {...props} />;
}
